import { AIGenerator } from 'page-ai-generator/generation';
import {COLORS} from '../Constants';
import { VIEW_STATUSES } from '../rx/actions/rxViewStatus';

const kEdgeToEdgeMode = 0;

const kCenterHandler = 0;
const kLeftHandler = 1;
// const kRightHandler = 2;
// const kLeftUpHandler = 3;
// const kRightUpHandler = 4;
// const kRightDownHandler = 5;
// const kLeftDownHandler = 6;
// const kLeftEdgeHandler = 7;
// const kRightEdgeHandler = 8;
// const kUpEdgeHandler = 9;

export const kDownEdgeHandler = 10;
export const kUpHandler = 11;
export const kDownHandler = 12;
const kSectionReorderHandler = 13;
const kBlockReorderHandler = 14;

const kDraggingThreshold = 20;
const kReroll = 21;
const kRerollNewBlock = 22
const cursorsHover = {
  [kReroll]: 'pointer',
  [kRerollNewBlock]:'pointer',
  [kBlockReorderHandler]: 'move'
}

export default class Manipulator{

    constructor(view){
        /**@type {Block[]} */
        this.blocks = [];
        this.isMousePressed = false;

        this.view = view;

        this.mode = kEdgeToEdgeMode;
        this.boundingRect = {x:0, y:0, width:0, height:0};
        this.handlerSize = 24;
        this.handlers = [];
        this.animations = {};
        this.animationStarted = false;
        this.anchorSize = 4;

        this.draggingThresholdCounter = kDraggingThreshold;

        this.blockReorderInfo = {
            rect: {},
            block: null,
            index: 0, //0 direct swap, -1 - place before, +1 - place behind
            direction: 0}; //0 vetical direct, 1 horizontal direction
        this.clickOffset = {x:0, y:0}


        const icons = [
          {
            src: `${process.env.PUBLIC_URL}/assets/icons/move.svg`,
            key: kBlockReorderHandler
          },
          {
            src: `${process.env.PUBLIC_URL}/assets/icons/reroll.svg`,
            key: kReroll
          }
          ,
          {
            src: `${process.env.PUBLIC_URL}/assets/icons/reroll.svg`,
            key: kRerollNewBlock
          }
        ]
        this.icons = {};
        for (const value of icons) {
          let icon = new Image();
          console.log('value.src', value.src);
          icon.src = value.src;
          this.icons[ value.key ]=icon;
        }

        console.log(this.icons);

    }

    setBlocks(blocks){
        this.blocks = blocks;
    }
    onScroll(value){
        if(this.isMousePressed){
            this.clickOffset.y -= value;
        }
    }
    onMouseDown(mousePos, ignoreCenterHandler){
        this.draggingThresholdCounter = kDraggingThreshold;
        if(this.blocks.length === 0){
            return false;
        }

        this.isMousePressed = true;
        for (var i = this.handlers.length - 1; i >= 0; i--) {

            let handler = this.handlers[i];
            let rect = this.handlerBoundingRect(handler.type);
            if (rect.x < mousePos.x &&
                rect.y < mousePos.y &&
                rect.width+rect.x > mousePos.x &&
                rect.height+rect.y > mousePos.y) {

                if (ignoreCenterHandler && handler.type === kSectionReorderHandler) {
                    continue;
                }
                handler.clicked = true;
                this.clickOffset = {
                    x: mousePos.x - this.boundingRect.x,
                    y: mousePos.y - this.boundingRect.y - this.view.overlay.scrollTop};

                if (handler.type === kReroll) {
                  this.blocks[0].rerollAiText();
                }
                if (handler.type === kRerollNewBlock) {
                    this.blocks[0].rerollAiTextForNewBlock();
                }
                return true;
            }
        }
        return false;
    }

    onMouseMove(mousePos, movement){
        //HOVER STATE
        for(let handler of this.handlers){
            handler.hovered = false;
            for (var i = this.handlers.length - 1; i >= 0; i--) {
                let handler = this.handlers[i];
                let rect = this.handlerBoundingRect(handler.type);
                if(rect.x < mousePos.x && rect.y < mousePos.y && rect.width+rect.x > mousePos.x && rect.height+rect.y > mousePos.y){
                    handler.hovered = true;
                    break;
                }
            }
        }
        //CLCIK HANDLE
        for (let handler of this.handlers) {
            if (handler.clicked) {
                if (handler.type === kSectionReorderHandler) {
                    let distance = Math.sqrt(movement.x*movement.x + movement.y*movement.y);
                    this.draggingThresholdCounter -= distance;
                    if (this.draggingThresholdCounter > 0 ) {
                        continue;
                    }
                    if (this.blocks[0] && !this.blocks[0].isDragging) {
                        this.blocks[0].setDragging( true );
                        this.view.setState({isMouseDragging: true});
                    }
                    let pos = {
                        x: mousePos.x*(1/this.view.state.zoom),
                        y: mousePos.y*(1/this.view.state.zoom)
                    }
                    this.blocks[0].setOffset( {
                        x: pos.x - this.clickOffset.x*(1/this.view.state.zoom),
                        y: pos.y - this.clickOffset.y*(1/this.view.state.zoom)
                    });

                    this.view.sortSections({x: pos.x,
                                            y: pos.y*this.view.state.zoom});
                } else if(handler.type === kBlockReorderHandler) {
                    if (this.blocks[0]) {
                        if (this.blocks[0] && !this.blocks[0].isDragging) {
                            for (let block of this.blocks[0].parent.children) {
                                if (block.type === 'Placeholder') {
                                    block.displayPlaceholder = true;
                                }
                            }

                            this.blocks[0].setDragging( true );
                            this.view.setState({isMouseDragging: true});
                        }
                        let pos = {
                            x: mousePos.x*(1/this.view.state.zoom),
                            y: mousePos.y*(1/this.view.state.zoom)
                        }
                        this.blocks[0].setOffset( {x: pos.x,
                                                   y: pos.y} );
                        this.updateBlockOrder( this.blocks[0], pos );
                    }
                }
            }
        }

    }



    updateBlockOrder( block, pos ){
        this.blockReorderInfo.block = null;
        this.blockReorderInfo.blockIndex = -1;
        let placementInfo = [];

        //Collect rectabgles
        for(let i=0; i < block.parent.children.length; i++){

            let sibling = block.parent.children[i];
            if(sibling.id === block.id){
                this.blockReorderInfo.blockIndex = i;
                continue;
            }
            if(!sibling.isVisible){
                continue;
            }
            ///Mid
            let rect = {
                x: sibling.worldRenderBRect.x,
                y: sibling.worldRenderBRect.y,
                width: sibling.worldRenderBRect.width,
                height: sibling.worldRenderBRect.height
            };

            placementInfo.push( {
                rect,
                block: sibling,
                index: i
            } );
        }
        for( const place of placementInfo){
            if(this.view.rectContainPoint(place.rect, pos.x, pos.y)){
                // console.log('block id:', place.block.id);
                this.blockReorderInfo.block = place.block;
                this.blockReorderInfo.rect = place.rect;
                this.blockReorderInfo.index = place.index;
                break;
            }
        }
    }

    onMouseUp(e){
        this.isMousePressed = false;

        let dragged = false;
        for(let handler of this.handlers){
            if((handler.type === kSectionReorderHandler || handler.type === kBlockReorderHandler) && handler.clicked){
                dragged = true;
            }
            handler.clicked = false;
        }

        if (dragged) {
            if (this.blocks[0] && this.blocks[0].isDragging) {
                this.blocks[0].setDragging( false );

                if (this.blocks[0].parent) {
                    for(let block of this.blocks[0].parent.children){
                        if(block.type === 'Placeholder'){
                            block.displayPlaceholder = false;
                        }
                    }
                }

                if (this.blockReorderInfo.block) {
                    //reorder block
                    let children = this.blockReorderInfo.block.parent.children;
                    let destinationBlock = children[this.blockReorderInfo.index];
                    if (destinationBlock.type == 'Placeholder') {
                        let index = this.blockReorderInfo.index;
                        children[index] = children.splice(this.blockReorderInfo.blockIndex, 1, children[index])[0];
                    } else {
                        let block = children.splice(this.blockReorderInfo.blockIndex, 1);
                        children.splice( this.blockReorderInfo.index, 0, block[0]);
                    }
                    this.blockReorderInfo.block = null;
                }
                this.view.overlay.selectBlock( this.blocks[0] );
                this.view.setState({isMouseDragging: false});
            }
        }
    }

    grabReorderHandler(){
        this.isMousePressed = true;
        for(let handler of this.handlers){
            if(handler.type === kSectionReorderHandler){
                handler.clicked = true;
                break;
            }
        }
        this.clickOffset = {x:200 * this.view.state.zoom,
                            y:(200 - this.view.overlay.scrollTop)*this.view.state.zoom};
    }

    selectionDidChanged(){
        this.update();
        if (this.blocks.length === 0) {
            return;
        }
        this.handlers = [];

        if (this.blocks[0].type === 'Background') {
            this.handlers = [
                {
                    clicked: false,
                    hovered: false,
                    type:kSectionReorderHandler
                },
            ];
        } else {
            if (this.blocks[0].isDraggable) {
                this.handlers = [
                    {
                        clicked: false,
                        hovered: false,
                        type: kCenterHandler
                    },
                    {
                        clicked: false,
                        hovered: false,
                        type:kBlockReorderHandler
                    }
                ];

                if (this.blocks[0].type == 'Text' && this.blocks[0].aiField) {
                  this.handlers.push({
                    clicked: false,
                    hovered: false,
                    type: kReroll
                  })
                }
                if (this.blocks[0].type == 'Text' && !this.blocks[0].aiField) {
                    this.handlers.push({
                      clicked: false,
                      hovered: false,
                      type: kRerollNewBlock
                    })
                  }
                
            }
        }
    }

    activeHandler(){
        for( let handler of this.handlers){
            if(handler.clicked){
                return handler.type;
            }
        }
    }

    update(){
        if (this.blocks && this.blocks.length !== 0) {
            this.boundingRect = this.blocks[0].worldRenderBRect;
        }
    }
    handlerBoundingRect(handler){
      if (!this.boundingRect && (this.blocks && this.blocks.length !== 0)) {
        this.boundingRect = this.blocks[0].worldRenderBRect || {x:0, y:0, width:0, height:0};
      }
      switch(handler){
          case kCenterHandler:
          case kSectionReorderHandler:
              return {
                  x: this.boundingRect.x,
                  y: this.boundingRect.y,
                  width: this.boundingRect.width,
                  height: this.boundingRect.height

              };

          case kBlockReorderHandler:
              let y =  this.boundingRect.y - 5 - this.handlerSize
              if( y < 0){
                  y = this.boundingRect.y + 5
              }
              return {
                  x: this.boundingRect.x + this.boundingRect.width/2.0 - this.handlerSize *0.5 + this.handlerSize*0.6,
                  y: y,
                  width: this.handlerSize,
                  height: this.handlerSize

              };
          case kReroll:
            return {
              x: this.boundingRect.x + this.boundingRect.width/2 - this.handlerSize * 0.5 - this.handlerSize + this.handlerSize*0.6,
              y: this.boundingRect.y - this.handlerSize - 5,
              width: this.handlerSize,
              height: this.handlerSize
            };
            case kRerollNewBlock:
            return {
              x: this.boundingRect.x + this.boundingRect.width/2 - this.handlerSize * 0.5 - this.handlerSize + this.handlerSize*0.6,
              y: this.boundingRect.y - this.handlerSize - 5,
              width: this.handlerSize,
              height: this.handlerSize
            };

            // case kLeftHandler:
            //     return{
            //         x: this.boundingRect.x - this.handlerSize,
            //         y: this.boundingRect.y + this.boundingRect.height*0.5 - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }

            // case kRightHandler:
            //     return{
            //         x: this.boundingRect.x + this.boundingRect.width - this.handlerSize,
            //         y: this.boundingRect.y + this.boundingRect.height*0.5 - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kUpHandler:
            //     return{
            //         x: this.boundingRect.x + this.boundingRect.width*0.5 - this.handlerSize,
            //         y: this.boundingRect.y - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }

            // case kDownHandler:
            //     return{
            //         x: this.boundingRect.x + this.boundingRect.width*0.5 - this.handlerSize,
            //         y: this.boundingRect.y + this.boundingRect.height - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kLeftUpHandler:
            //     return{
            //         x: this.boundingRect.x - this.handlerSize,
            //         y: this.boundingRect.y - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kRightUpHandler:
            //     return{
            //         x: this.boundingRect.x+this.boundingRect.width - this.handlerSize,
            //         y: this.boundingRect.y - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kRightDownHandler:
            //     return{
            //         x: this.boundingRect.x+this.boundingRect.width - this.handlerSize,
            //         y: this.boundingRect.y + this.boundingRect.height - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kLeftDownHandler:
            //     return{
            //         x: this.boundingRect.x - this.handlerSize,
            //         y: this.boundingRect.y + this.boundingRect.height - this.handlerSize,
            //         width: this.handlerSize*2,
            //         height: this.handlerSize*2
            //     }
            // case kLeftEdgeHandler:
            //     return{
            //         x:this.boundingRect.x-this.anchorSize,
            //         y:this.boundingRect.y+this.handlerSize,
            //         width:this.anchorSize*2,
            //         height:this.boundingRect.height-this.handlerSize*2
            //     }
            // case kRightEdgeHandler:
            //     return{
            //         x:this.boundingRect.x+this.boundingRect.width-this.anchorSize,
            //         y:this.boundingRect.y+this.handlerSize,
            //         width:this.anchorSize*2,
            //         height:this.boundingRect.height-this.handlerSize*2
            //     }
            // case kUpEdgeHandler:
            //     return{
            //         x:this.boundingRect.x+this.handlerSize,
            //         y:this.boundingRect.y-this.anchorSize,
            //         width:this.boundingRect.width-this.handlerSize*2,
            //         height:this.anchorSize*2
            //     }
            // case kDownEdgeHandler:
            //     return{
            //         x:this.boundingRect.x+this.handlerSize,
            //         y:this.boundingRect.y+this.boundingRect.height-this.anchorSize,
            //         width:this.boundingRect.width-this.handlerSize*2,
            //         height:this.anchorSize*2
            //     }
            default:
                break;
        }
    }

    renderHandler(ctx, handler){
        if(handler.type === kCenterHandler ||
            handler.type === kSectionReorderHandler ||
            (handler.invisible && !handler.clicked && !handler.hovered)){
            return;
        }

        let rect = this.handlerBoundingRect(handler.type);

        if (!handler.hideFill) {
          if(handler.clicked){
              ctx.fillStyle = '#8960FF';
          }
          else if(handler.hovered){
              ctx.fillStyle = '#6C68FF';
          }
          else {
              ctx.fillStyle = 'rgb(41,44,48, 0.8)';
          }
        } else {
          ctx.fillStyle = 'transparent';
          if(handler.hovered){
            ctx.fillStyle = 'rgb(41,44,48, 0.2)';
          }
        }
        ctx.fillRect(
            rect.x,
            rect.y,
            rect.width,
            rect.height);
        const icon = this.icons[ handler.type ];
        if(icon){
            ctx.drawImage(icon, rect.x+4, rect.y+4);
        }

    }

    renderOverlay( ctx ){
        if(this.blocks.length === 0){
            return;
        }

        if( !this.blocks[0].isDragging) {
            let hovered = 'unset';
            for(let handler of this.handlers){
                this.renderHandler(ctx, handler);
                if (handler.hovered && cursorsHover[handler.type]) {
                  hovered = cursorsHover[handler.type];
                }
            }
            ctx.canvas.parentElement.style.cursor = hovered;
            ctx.canvas.style.cursor = hovered;
        }

        if(this.blockReorderInfo.block){
            ctx.strokeStyle = '#1983fc';
            ctx.fillStyle = 'rgb(240,240,240, 0.2)';
            ctx.lineWidth = 2;
            let rect = this.blockReorderInfo.rect;
            ctx.fillRect(
                rect.x,
                rect.y,
                rect.width,
                rect.height);
            ctx.strokeRect(
                rect.x,
                rect.y,
                rect.width,
            rect.height);
        }
    }
}